module.exports = __webpack_public_path__ + "img/step6.28ee7820.png";